module.exports = __webpack_public_path__ + "img/alex_myprofile_grey.de788453.svg";